import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  GET_ALL_CITIES,
  GET_ALL_COUNTRIES,
  GET_ALL_CURRENCIES,
  GET_ALL_ROLES,
} from "./actionTypes";

import {
  getAllCitiesFailure,
  getAllCitiesSuccess,
  getAllCountriesFailure,
  getAllCountriesSuccess,
  getAllCurrenciesFailure,
  getAllCurrenciesSuccess,
  getAllRolesFailure,
  getAllRolesSuccess,
} from "./actions";
import {
  getAllCurrenciesApi,
  getAllCountriesApi,
  getAllCitiesApi,
  getAllRolesApi,
} from "api/data";

function* getAllCountries({ payload }) {
  try {
    const { data } = yield call(getAllCountriesApi, payload);
    yield put(getAllCountriesSuccess(data));
  } catch (error) {
    yield put(getAllCountriesFailure(error.response.data || error));
  }
}

function* getAllCurrencies({ payload }) {
  try {
    const { data } = yield call(getAllCurrenciesApi, payload);
    yield put(getAllCurrenciesSuccess(data));
  } catch (error) {
    yield put(getAllCurrenciesFailure(error.response.data || error));
  }
}

function* getAllCities({ payload }) {
  try {
    const { data } = yield call(getAllCitiesApi, payload);
    yield put(getAllCitiesSuccess(data));
  } catch (error) {
    yield put(getAllCitiesFailure(error.response.data || error));
  }
}

function* getAllRoles({ payload }) {
  try {
    const { data } = yield call(getAllRolesApi, payload);
    yield put(getAllRolesSuccess(data));
  } catch (error) {
    yield put(getAllRolesFailure(error.response.data || error));
  }
}

export function* watchGetAllCities() {
  yield takeEvery(GET_ALL_CITIES, getAllCities);
}

export function* watchGetAllCurrencies() {
  yield takeEvery(GET_ALL_CURRENCIES, getAllCurrencies);
}

export function* watchGetAllCountries() {
  yield takeEvery(GET_ALL_COUNTRIES, getAllCountries);
}

export function* watchGetAllRoles() {
  yield takeEvery(GET_ALL_ROLES, getAllRoles);
}

function* dataSaga() {
  yield all([fork(watchGetAllCurrencies)]);
  yield all([fork(watchGetAllCountries)]);
  yield all([fork(watchGetAllCities)]);
  yield all([fork(watchGetAllRoles)]);
}

export default dataSaga;
